<template>
	<div :class="isPc == true ? 'manager warp' : ''">
		<div>
			<div v-if="isPc == true" class="breadcrumb greyfont warp">
				<ul>
					<li>{{ title }}</li>
				</ul>
			</div>

			<!-- pc端导航 -->
			<div v-if="isPc == true" class="horizontal-container">
				<div class="scroll-wrapper" ref="scroll">
					<div class="scroll-content bluefont">
						<div
							class="scroll-item"
							:style="tabar_list_cur == index ? 'background:linear-gradient(to top, #005FB2, #2583D4);color: #fff;' : ''"
							@click="tabarchange(index)"
							v-for="(item, index) in tabar_list"
							:key="index"
						>
							<p>{{ item }}</p>
						</div>
					</div>
				</div>
			</div>

			<!-- 手机端导航 -->
			<div v-if="isPc == false" class="mob-tabar">
				<ul class="warp-mob bluefont">
					<li
						:style="tabar_list_cur == index ? 'background:linear-gradient(to top, #005FB2, #2583D4);color: #fff;' : ''"
						@click="tabarchange(index)"
						v-for="(item, index) in tabar_list"
						:key="index"
					>
						{{ item }}
					</li>
				</ul>
			</div>
			<div v-if="data" class="manager_cont">
				<ul v-if="isPc == true" class="manager_cont_list">
					<li @click="getpage(item.id)" class="manager_cont_list_item" v-for="item in data" :key="item.tiem">
						<div class="manager_cont_list_item_date bluefont">
							<h1>
								{{ item.createtime.substring(8, 10) }}
								<p>/{{ item.createtime.substring(5, 7) }}</p>
							</h1>
						</div>
						<div class="manager_cont_list_item_text">
							<h2>{{ item.title }}</h2>
							<p>{{ item.introduction }}</p>
						</div>
					</li>
				</ul>
				<ul v-if="isPc == false" class="manager_cont_list-mob warp-mob">
					<li @click="getpage(item.id)" class="manager_cont_list_item" v-for="item in data" :key="item.tiem">
						<div class="manager_cont_list_item_date bluefont">
							<h1>
								{{ item.createtime.substring(8, 10) }}
								<p>/{{ item.createtime.substring(5, 7) }}</p>
							</h1>
							<h2>{{ item.title }}</h2>
							<span>></span>
						</div>
						<div class="manager_cont_list_item_text">
							<p>{{ item.introduction }}</p>
						</div>
					</li>
				</ul>
			</div>
			<div v-if="isPc == true && data" class="manager_pagination warp">
				<el-pagination
					@current-change="handleCurrentChange"
					background
					:current-page="currentPage"
					layout="prev, pager, next"
					:total="data_length"
					:page-size="page_size"
				></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import BScroll from '@better-scroll/core';

export default {
	name: 'WebLijinhospitalManageHospital',

	data() {
		return {
			isPc: true,
			pid: 0,
			title: '',
			tabar_list: [],
			tabar_list_cur: 0,
			data: null,
			currentPage: 1, // 当前页
			data_length: 0,
			page_size: 5

			// List: [ '医院文化',  '职工天地', '医疗保险','药事管理',  '医院感染管理', '信息公开', '投诉电话', '医院文化', '职工天地', '医疗保险', '药事管理',  '医院感染管理',  '信息公开', '投诉电话',  '医院文化','职工天地',  '医疗保险', '药事管理','医院感染管理', '信息公开', '投诉电话', ],
		};
	},

	mounted() {
		if ('id' in this.$route.query) {
			this.pid = this.$route.query['id'];
			this.title = this.$route.query['name'];
		} else {
			console.log('error');
		}
		if (document.body.clientWidth <= 820) {
			this.isPc = false;
			console.log(this.isPc);
		} else {
			this.isPc = true;
			console.log(this.isPc);
		}
		this.getdata(0);
		this.init();
	},

	methods: {
		handleCurrentChange(pageNumber) {
			this.currentPage = pageNumber;
			this.getdata(this.tabar_list_cur);
		},
		tabarchange(index) {
			this.currentPage = 1;
			this.tabar_list_cur = index;
			this.getdata(this.tabar_list_cur);
		},
		// 内容页
		getpage(e) {
			this.$router.push({
				path: '/content',
				query: { title: this.tabar_list[this.tabar_list_cur], id: e }
			});
		},
		getdata(i) {
			let _t = this;
			this.$axios({
				url: 'http://www.ljxzxyy.cn/api/index/article',
				params: {
					pid: _t.pid
				}
			})
				.then((res) => {
					//请求成功
					console.log('article', res.data.data);
					let plist = res.data.data;
					let index_arr = [];
					for (var i1 = 0; i1 < plist.length; i1++) {
						_t.tabar_list[i1] = plist[i1]['nickname'];
						index_arr[i1] = plist[i1]['id'];
					}
					let category_id = index_arr[i];
					this.$axios({
						url: 'http://www.ljxzxyy.cn/api/index/article',
						params: {
							category_id: category_id,
							num: this.page_size,
							page: this.currentPage
						}
					})
						.then((res) => {
							//请求成功
							console.log('article', res.data);
							this.data = res.data.data.list;
							this.data_length = res.data.data.count;
						})
						.catch((error) => {
							//请求失败
							console.log('article', error);
						});
				})
				.catch((error) => {
					//请求失败
					console.log('article', error);
				});
		},
		init() {
			this.bs = new BScroll(this.$refs.scroll, {
				scrollX: true,
				probeType: 3 // listening scroll event
			});
			this.bs.on('scrollStart', () => {
				console.log('scrollStart-');
			});
			this.bs.on('scroll', () => {
				console.log('scrolling-');
			});
			this.bs.on('scrollEnd', () => {
				console.log('scrollingEnd');
			});
		}
	}
};
</script>

<style lang="scss" scoped></style>
